// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"3274d164","235":"fac5d855","251":"b9efe355","395":"fd6df8c3","453":"de78b977","522":"e181f481","671":"cb751ff7","683":"e7b8bfce","706":"2a558cc7","731":"f157acfe","810":"dabb24d3","827":"bb2737ee","885":"d37ee596"}[chunkId] + ".chunk.js";
};